import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { LogoMark } from "../../context/BrandContext";
import { TextInput } from "../../components/admin/AdminUI";
import { errorMessage } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email.trim(), password); } catch (err) { setError(errorMessage(err, "Login failed")); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F7F8FA] grid-lines px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="panel w-full max-w-sm p-8" data-testid="admin-login-form">
        <LogoMark size="w-14 h-14" testid="admin-login-logo" />
        <h1 className="mt-5 font-display font-black uppercase text-slate-900 text-3xl">Staff login</h1>
        <p className="mt-1 text-sm text-slate-600">Echevarria Trucking admin panel</p>
        <div className="mt-6 space-y-4">
          <TextInput label="Email" type="email" value={email} onChange={setEmail} testid="admin-login-email" autoComplete="username" required />
          <TextInput label="Password" type="password" value={password} onChange={setPassword} testid="admin-login-password" autoComplete="current-password" required />
        </div>
        {error && <p className="mt-4 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-amber w-full mt-6" data-testid="admin-login-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Log in"}
        </button>
        <Link to="/" className="block mt-5 text-center text-xs text-slate-500 hover:text-brand-600">Back to website</Link>
      </form>
    </div>
  );
}
